// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tl8TT","productName":"Table_productName__1pFwz"};